import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { ChatMessage } from './ChatMessage';

export function ChatContainer({ history = [], sessionId = null, onRate = null, onQuickReply = null }) {
  const prevHistoryLengthRef = useRef(history.length);
  const [newMessageIndex, setNewMessageIndex] = useState(null);

  // Track when a new message is added to enable typewriter
  useEffect(() => {
    if (history.length > prevHistoryLengthRef.current) {
      // New message added - enable typewriter for the last message
      setNewMessageIndex(history.length - 1);
    }
    prevHistoryLengthRef.current = history.length;
  }, [history.length]);

  return (
    <div className="flex flex-col space-y-3 sm:space-y-4 md:space-y-6">
      {history?.map((msg, index) => (
        <ChatMessage
          key={msg.id || msg.created_at || index}
          message={msg}
          enableTypewriter={index === newMessageIndex}
          messageId={msg.id}
          sessionId={sessionId}
          ratings={msg.ratings}
          onRate={onRate}
          onQuickReply={onQuickReply}
          isLastMessage={index === history.length - 1}
        />
      ))}
    </div>
  );
}

ChatContainer.propTypes = {
  history: PropTypes.array,
  sessionId: PropTypes.string,
  onRate: PropTypes.func,
  onQuickReply: PropTypes.func,
};
